const formatNumber = (value: number) => {
	return new Intl.NumberFormat('tr-TR', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(value);
}

export default formatNumber;